import { FormControlLabel, Stack, Switch, Slider, IconButton } from '@mui/material';

type Props = {
  volume: {
    value: number;
    onChange: (value: number) => void;
  };
  mute: {
    value: boolean;
    onToggle: () => void;
  };
  onReplay: () => void;
  showReplay: boolean;
  translation: Record<string, string>;
};

export function Volume({ volume, mute, showReplay, onReplay, translation }: Props) {
  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <FormControlLabel
        control={<Switch checked={mute.value} onChange={mute.onToggle} />}
        label={translation?.sound || 'Sound'}
      />
      {showReplay && (
        <IconButton sx={{ color: '#fff' }} onClick={onReplay}>
          <i className="far fa-play" />
        </IconButton>
      )}
      <Slider
        min={0}
        max={1}
        step={0.1}
        value={volume.value}
        onChange={(_, value) => volume.onChange(value as number)}
        aria-label="Sound"
        valueLabelDisplay="auto"
      />
    </Stack>
  );
}
